<template>
	<v-hover v-slot="{ hover }">
		<div class="font-weight-medium text-start px-3 py-3 rounded-0 cursor-pointer d-flex align-center"
			@click="action"
			v-bind:class="{ 'primary--text accent lighten-2' : hover, 'grey--text text--darken-2' : !hover, 'font-12': small, 'font-14': !small }">

			<v-icon v-if="icon" class="mr-2 dropdown-icon" v-bind:class="{ 'primary--text accent lighten-2' : hover }">{{ icon }}</v-icon>{{ text }}
		</div>
	</v-hover>
</template>

<script>
export default {
	name: "PostDropdownButton",
	props: {
		text: {
			type: String,
			required: true
		},
		icon: {
			type: String,
			default: ''
		},
		action: {
			type: Function,
			default: function () {
				alert('akcja jest niepodpięta')
			}
		},
		small: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>
	.dropdown-icon {
		width: 32px;
	}
</style>
